
import api from '../../../../api/worktime'

// eslint-disable-next-line no-unused-vars
export default {
      directives: {
      },
      props: {
        config: {
          fields: String,
          data: []
        },
        context: {}
    },
    data () {
      return {
        isLoading: true,
        height: 400,
        styles: null,
        width: null,
        cssClasses: null,
        datasetIdKey: null,
        plugins: [],
        chartId: 'chart-'+(Math.random() + 1).toString(36).substring(7),
        chartData: {
          labels: [
          ],
          datasets: [
          ]
        },
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    computed: {
     
    }, watch: {
      context: function() {
        this.update();
      }
    },
    methods: {
      update() {
          const me = this;
          me.isLoading=true;
          api.getWidgetData(this.config.id, this.context, (res) => {
              me.isLoading=false;
              let fields = JSON.parse(me.config.fields);
              //me.chartId = fields.chartId;
              me.chartData.labels=me.getValues(res, fields.labelField, true);
              let datasets = fields.datasets;
              for (let dataset of datasets) {
                  dataset.label = me.st(dataset.label);
                  dataset.data= me.getValues(res, dataset.dataField, false);
                  if (dataset.backgroundColorField) {
                    dataset.backgroundColor= me.getValues(res, dataset.backgroundColorField);
                  }
              }
              me.chartData.datasets=datasets;
          }, err => {
              console.log(err); //TODO: mostrar toast?
              this.isLoading=false;
          })
      
      },
      getValues(data, field, localized) {
          
          let values = [];
          for (let row of data) {
              values.push(localized?this.st(row[field]):row[field]);
          }
          return values;
      }
  }
}